const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>The Pips currency converter</h1>
        <p>
          Calculate foreign exchange rates and convert all major and exotic
          currency pairs with our easy-to-use currency converter.
        </p>
        <br></br><br></br>
      </div>
    </div>
  );
};

export default TopicOne;
